import { useIsAuthenticated } from '@azure/msal-react';

import { getAuthMode } from '@frontend/features/auth/util/util.auth.getAuthMode';
import { hasLocalToken } from '@frontend/features/auth/util/util.auth.localToken';

/**
 * Custom hook that checks authentication status across both auth modes
 *
 * **E2E Mode** (token in localStorage):
 * - Returns true if localStorage token exists
 * - Works on all environments (localhost, dev, qa, prod)
 *
 * **MSAL Mode** (no token in localStorage):
 * - Uses MSAL's useIsAuthenticated hook
 * - Returns true if user is logged in via Azure AD
 *
 * @returns true if user is authenticated, false otherwise
 */
export function useIsAuthenticatedLocal(): boolean {
  // Get MSAL authentication status (only used in MSAL mode)
  const msalAuthenticated = useIsAuthenticated();

  const authMode = getAuthMode();

  // E2E mode: check if localStorage token exists
  if (authMode === 'e2e') {
    return hasLocalToken();
  }

  // MSAL mode: use MSAL authentication status
  return msalAuthenticated;
}
